// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ee2d5baf","244":"10810b00","566":"eba0323f","654":"71886b8f","789":"ba70ad8f","797":"18e7ec04","826":"c217573a","859":"7595679e"}[chunkId] + ".chunk.js";
};